module.exports = __webpack_public_path__ + "img/d1d6f6f.png";